import isEmpty from 'lodash/isEmpty';
import PubSub from '../services/pubsub-service';
import * as PubSubActionType from '../constants/pubus-action-type';
import * as UserActionType from './constants';
// import * as UnitHelper from '../helper/unit-helper';

const defaultParams = {
  searchKey: '',
  skip: 1,
  take: 10,
  sort: { field: 'fullName', order: 'ascending' },
  status: 'all',
  totalRecord: 0,
  totalPage: 0
};

const ManageUser = {
  items: [],
  params: defaultParams
};

const UserProfile = {
  userId: '',
  clientId: '',
  fullName: '',
  firstName: '',
  lastName: '',
  email: '',
  normalizedRoleName: '',
  roleName: ''
};

const InviteUser = {
  IsHiddenSearchEmail: false,
  IsHiddenNonSystemUser: true,
  IsHiddenTenantUser: true,
  IsHiddenSystemUser: true,
  IsBack: false
};

const UserState = {
  ManageUser: ManageUser,
  UserProfile: UserProfile,
  UserProfileByEmail: UserProfile,
  ErrorMsg: [],
  IsOpenFormEdit: false,
  IsOpenFormChangePassword: false,
  InviteUser: InviteUser
};

export default function UserStore(state = UserState, action) {
  switch (action.type) {
    case UserActionType.SEARCH_SUCCESS:
      return processSearch(state, action);
    case UserActionType.GET_USER_BY_USERID_SUCCESS:
      return processGetUserByUserId(state, action);
    case UserActionType.GET_USER_BY_EMAIL_SUCCESS:
      return processInvite(state, action);
    case UserActionType.RESET_INVITE_USER:
      return processResetInvite(state, action);
    case UserActionType.INVITE_USER_SUCCESS:
      return processInviteSuccess(state, action);
    case UserActionType.UPDATE_MY_PROFILE_SUCCESS:
      return processUpdateMyProfile(state, action);
    case UserActionType.UPDATE_PROFILE_PHOTO_SUCCESS:
      return processprofilephotoSuccess(state, action);
      case UserActionType.REMOVE_PROFILE_PHOTO_SUCCESS:
        return processprofilephotoremove(state, action);
    case UserActionType.EDIT_USER_ERROR:
      return processEditUserError(state, action);
    case UserActionType.OPEN_FORM_CHANGE_PASSWORD:
      return {
        ...state,
        IsOpenFormChangePassword: true
      };
    case UserActionType.CLOSE_FORM_CHANGE_PASSWORD:
      return {
        ...state,
        ErrorMsg: [],
        IsOpenFormChangePassword: false
      };
    case UserActionType.CHANGE_PASSWORD_SUCCESS:
      return processChangePasswordSuccess(state, action);
    case UserActionType.CHANGE_PASSWORD_ERROR:
      return processChangePasswordError(state, action);
    case UserActionType.RESET_MANAGE_USER:
      return {
        ...state,
        ManageUser: ManageUser
      };
    case UserActionType.UPDATE_LOGO_COMPANY_SUCCESS:
      return {
        ...state,
        UserProfile: {
          ...state.UserProfile,
          logoUrl: action.data
        }
      };
    case UserActionType.UPDATE_HO_LOGO_COMPANY_SUCCESS:
    return {
      ...state,
      UserProfile: {
        ...state.UserProfile,
        hoLogoUrl: action.data
      }
    };  
    default:
      return state;
  }
}

const processInvite = (state, action) => {

  var result = action.data.item === null ? UserProfile : action.data.item;

  var inviteUser = {
    IsHiddenSearchEmail: false,
    IsHiddenNonSystemUser: true,
    IsHiddenTenantUser: true,
    IsHiddenSystemUser: true,
    IsBack: false
  };

  if (!isEmpty(result.clientId) && !isEmpty(result.userId)) {
    inviteUser.IsHiddenSearchEmail = true;
    inviteUser.IsHiddenTenantUser = false;
  } else if (isEmpty(result.clientId) && !isEmpty(result.userId)) {
    inviteUser.IsHiddenSearchEmail = true;
    inviteUser.IsHiddenSystemUser = false;
  } else {
    result.email = action.data.searchEmail;
    inviteUser.IsHiddenSearchEmail = true;
    inviteUser.IsHiddenNonSystemUser = false;
  }

  return {
    ...state,
    UserProfileByEmail: result,
    InviteUser: inviteUser
  };
};

const processInviteSuccess = (state) => {
  return {
    ...state,
    InviteUser: { ...InviteUser, IsBack: true }
  };
};

const processResetInvite = (state) => {
  return {
    ...state,
    InviteUser: {
      IsHiddenSearchEmail: false,
      IsHiddenNonSystemUser: true,
      IsHiddenTenantUser: true,
      IsHiddenSystemUser: true,
      IsBack: false
    }
  };
};

const processSearch = (state, action) => {
  var result = action.data;
  var manageUser = {
    items: result.data.items,
    params: {
      totalRecord: result.data.totalRecord,
      totalPage: result.data.totalPage,
      skip: result.params.skip + 1,
      take: result.params.take,
      status: result.params.status,
      email: result.params.email,
      sort: { field: result.params.sortField, order: result.params.sortOrder }
    }
  };
  return {
    ...state,
    ManageUser: manageUser,
    ErrorMsg: [],
    IsOpenFormEdit: false,
    SuccessMsg: ''
  };
};

const processGetUserByUserId = (state, action) => {
  return {
    ...state,
    UserProfile: action.data,
    ErrorMsg: [],
    IsOpenFormEdit: true,
    SuccessMsg: ''
  };
};

const processEditUserError = (state, action) => {
  return {
    ...state,
    ErrorMsg: [action.data.error],
    UserProfile: {
      ...state.UserProfile,
      email: action.data.params.email
    }
  };
};

const processUpdateMyProfile = (state, action) => {

  PubSub.publish(PubSubActionType.UPDATE_DISPLAYNAME_AND_AVATAR, {
    displayName: action.data.firstName + ' ' + action.data.lastName,
    avatar: ''
  });

  return {
    ...state,
    UserProfile: action.data
  };
};

const processprofilephotoSuccess = (state) => {
  return {
    ...state,
    ErrorMsg: [],
  };
};


const processprofilephotoremove = (state) => {
  return {
    ...state,
    ErrorMsg: [],
  };
};


const processChangePasswordSuccess = (state) => {
  return {
    ...state,
    ErrorMsg: [],
    IsOpenFormChangePassword: false
  };
};

const processChangePasswordError = (state, action) => {
  return {
    ...state,
    ErrorMsg: action.data
  };
};




// WEBPACK FOOTER //
// ./src/User/reducers.js